import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Sale } from 'src/app/models/sales/sales.model';
import { SaleState } from './sales.reducer';

const selectState = createFeatureSelector<SaleState>('sales');

export const selectSales = createSelector(selectState, (state: SaleState) => {
  return state.sales;
});

export const selectSalesActiveForSubmission = createSelector(
  selectSales,
  (sales: Sale[]) => {
    return sales.filter(
      (sale) => !!sale.isSubmissionAllowed && !!sale.isSubmitDateApplicable
    );
  }
);

export const selectSalesLoaded = createSelector(
  selectState,
  (state: SaleState) => state.salesLoaded
);

export const salesListError = createSelector(
  selectState,
  (state: SaleState) => state.salesListError
);

export const selectSaleHorses = createSelector(
  selectState,
  (state: SaleState) => {
    return state.saleHorses;
  }
);

export const selectSaleHorse = createSelector(
  selectState,
  (state: SaleState) => {
    return state.saleHorse;
  }
);

export const selectUpdateSaleMemberAccess = createSelector(
  selectState,
  (state: SaleState) => state.isUpdatedSaleMemberAccess
);

export const selectSaleMemberPermission = createSelector(
  selectState,
  (state: SaleState) => state.saleMemberPermission
);


export const selectSaleHorsesLoaded = createSelector(
  selectState,
  (state: SaleState) => state.salesLoaded
);

export const saleProfileError = createSelector(
  selectState,
  (state: SaleState) => state.saleProfileError
);

export const selectSaleMemberAccess = createSelector(
  selectState,
  (state: SaleState) => state.saleMemberAccess
);

export const selectSyncSaleHorse = createSelector(
  selectState,
  (state: SaleState) => state.syncSaleHorse
);

export const selectStautsSaleHorse = createSelector(
  selectState,
  (state: SaleState) => state.stautsSaleHorse
);
export const selectSaleStatuses = createSelector(
  selectState,
  (state: SaleState) => state.saleStatuses
);

export const selectSaleStatusesLoaded = createSelector(
  selectState,
  (state: SaleState) => state.isSaleStatusesLoaded
);
